import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store , persistor} from './store';
import { PersistGate } from 'redux-persist/integration/react';
import SplashScreen from './Components/SplashScreen';

const SPLASH_SHOWN_KEY = 'ifinds_splash_shown';

const AppWithSplash: React.FC = () => {
  const [showSplash, setShowSplash] = useState(false);

  useEffect(() => {
    // Check if splash has been shown in this session
    const splashShown = sessionStorage.getItem(SPLASH_SHOWN_KEY);
    
    // Only show splash if it hasn't been shown in this session
    if (!splashShown) {
      setShowSplash(true);
      // Mark as shown immediately to prevent showing on refresh
      sessionStorage.setItem(SPLASH_SHOWN_KEY, 'true');
    }
  }, []);

  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  return (
    <>
      {showSplash && (
        <SplashScreen 
          onComplete={handleSplashComplete}
          duration={2500}
        />
      )}
      <App />
    </>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppWithSplash />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
